"use strict";
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const __1 = require("..");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Badge = ({ label, variant, className }) => (core_1.jsx("div", { className: carabiners_1.joinStr(styles_scss_1.default.badge, styles_scss_1.default[variant], className) },
    core_1.jsx(__1.HelperText, null, label)));
Badge.defaultProps = {
    label: '',
    variant: 'primary',
    className: ''
};
exports.default = Badge;
